/** Bar colors for TCP Benchmarking column charts only (distinct from PC benchmarking). */
export interface TcpBenchmarkBarColors {
  fill: string;
  hover: string;
  border: string;
  gradientTop: string;
  gradientBottom: string;
  hoverBorder: string;
}

export function getTcpBenchmarkBarColors(isDark: boolean): TcpBenchmarkBarColors {
  if (isDark) {
    return {
      fill: '#0f766e',
      hover: '#14b8a6',
      border: 'rgba(148, 163, 184, 0.35)',
      gradientTop: '#2dd4bf',
      gradientBottom: '#0f766e',
      hoverBorder: 'rgba(45, 212, 191, 0.85)',
    };
  }

  return {
    fill: '#0d9488',
    hover: '#0f766e',
    border: 'rgba(100, 116, 139, 0.35)',
    gradientTop: '#5eead4',
    gradientBottom: '#0d9488',
    hoverBorder: 'rgba(13, 148, 136, 0.85)',
  };
}
